export default __webpack_public_path__ + "static/media/arrow_dropdown-dark.336d16f6.svg";